/* eslint-disable react/destructuring-assignment */
/* eslint-disable jsx-a11y/label-has-associated-control */

import React from 'react';
import { components, OptionProps } from 'react-select';
import cn from 'classnames';
import { TSelectOptionsType } from 'domains/ReportBuilder/types';
import css from '../styles.module.scss';

type TOptionProps = OptionProps<TSelectOptionsType, true> & {
  showSubtitleInOption?: boolean;
};

const Option = ({
  showSubtitleInOption,
  ...props
}: TOptionProps): JSX.Element => (
  <components.Option {...props} className={css.hashOption}>
    <label className={css.hashOption__label}>
      <div
        className={cn(css.checkbox, {
          _isChecked: props.isSelected,
        })}
      />
      <div className={css.content}>
        <div className={css.name}>{props.label}</div>

        {showSubtitleInOption && (
          <div className={css.hash}>{props.data.value}</div>
        )}
      </div>
    </label>
  </components.Option>
);

export default Option;
